import { useState } from "react";

import { Column } from "@/components/Column";
import { PlacementTabQueryOptions } from "@/components/PlacementTabQueryOptions";
import { PlacementTabTable } from "@/components/PlacementTabTable";

import { useGetPlacements } from "@/hooks/queries/useGetPlacements";
import { defaultPlacementQueryParams } from "@/lib/constants";
import { cn } from "@/lib/utils";
import { Job, PlacementQueryParams } from "@/types";

export const PlacementTab = ({
  className,
  job,
}: {
  className: string;
  job: Job;
}) => {
  const [placementQueryParams, setPlacementQueryParams] =
    useState<PlacementQueryParams>(defaultPlacementQueryParams);

  const { data: placements, status: placementsStatus } = useGetPlacements({
    jobId: job.id,
    queryOptions: defaultPlacementQueryParams,
  });

  if (placementsStatus === "pending") {
    // TODO: Loading state.
    return null;
  } else if (placementsStatus === "error") {
    // TODO: Error state.
    return null;
  }

  return (
    <Column className={cn("gap-2", className)}>
      <PlacementTabQueryOptions
        placementQueryParams={placementQueryParams}
        setPlacementQueryParams={setPlacementQueryParams}
      />
      <PlacementTabTable
        job={job}
        placements={placements}
        placementQueryParams={placementQueryParams}
      />
    </Column>
  );
};
